import { Box, IconButton } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import React from "react";
import SearchInput from "app/components/SearchInput";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import RefreshIcon from '@mui/icons-material/Refresh';
import EditorsSelect from "app/components/EditorSelect";

export default function Header({ disabled, resetFilters }: { disabled?: boolean; resetFilters(): void; }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
    const searchParams  = useSearchParams();
  const editorParam = searchParams?.[0]?.get("user");


  const handleResetFilters = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete("q");
    params.delete("user");
    navigate(`?${params.toString()}`);
    resetFilters()
    
  }

  const setUserSearchQuery = (user: string) => {
    const params = new URLSearchParams(window.location.search);
    if (user.toLowerCase() == "all") {
      params.delete("user");
    }else{
      params.set("user", user);
    }
    navigate(`?${params.toString()}`);
  };
  
  return (
    <>
      <Grid2 xs={4}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <SearchInput
            disabled={disabled}
            provisionLabel
          />
        </Box>
      </Grid2>
      <Grid2 xs={4}>
        <EditorsSelect
          label={t("STATIONS.FORM.LABELS.CREATOR_NAME")}
          isFieldReq={false}
          backgroundColor="#F3F6F8"
          borderWidth={0}
          disabled={disabled}
          onChange={(value) => setUserSearchQuery(value?.value || '')}
          value={editorParam ? {value: editorParam, label: ''} : undefined}
        />
      </Grid2>
      <Grid2 xs={1} display={'flex'}  justifyContent={'center'} alignItems={'center'}>
      <IconButton
          onClick={handleResetFilters}
        >
          <RefreshIcon />
        </IconButton>
      </Grid2>
    </>
  );
}
